<template>
    <div class="pdp-base-content">
        <!-- Loading -->
        <loading />

        <!-- Base Sidebar  -->
        <div class="sidebar-content-wraper">
            <!-- Content -->
            <div class="content-pdp">
                <!-- Content Base Pdp -->
                <div class="content-base-pdp">
                    <!-- Turn Back -->
                    <div class="turn-back">
                        <div
                            class="button-icon-wrapper goback-btn"
                            role="button"
                            @click="turnBack()"
                        >
                            <span class="color-text-action"></span>
                            <p class="button-body color-text-action">Voltar</p>
                        </div>

                        <div
                            class="button-icon-wrapper share-btn d-none"
                            role="button"
                        >
                            <span class="color-text-action"></span>
                            <p class="button-body color-text-action">
                                Partilhar
                            </p>
                        </div>
                    </div>

                    <header class="pdp-base-title">
                        <p class="">{{ addressStructure(productData) }}</p>
                        <h1 class="heading-2">{{ productData.name }}</h1>
                    </header>

                    <!-- Pdp Content Image -->
                    <div class="pdp-content-images">
                        <div class="pdp-main-image">
                            <img
                                :src="pdpimage.media_original"
                                :alt="`${productData.name} - Offices`"
                            />
                        </div>

                        <div class="pdp-image-list" role="list">
                            <div
                                v-for="(valmedia, indexmedia) in mediaData"
                                :key="indexmedia"
                                :data-referindex="indexmedia"
                                class="pdp-image"
                                @click="changePdpImage($event)"
                            >
                                <img
                                    :data-referindex="indexmedia"
                                    @click="changePdpImage($event)"
                                    :src="checkPdpImage(valmedia)"
                                    :alt="`${productData.name} - Thumb`"
                                />
                            </div>
                        </div>
                    </div>

                    <!-- Content Info -->
                    <div class="pdp-info-content">
                        <!-- Basic Info -->
                        <div class="pdp-info-content-base">
                            <!-- Nav Tabs -->
                            <ul class="nav nav-tabs" id="pdpTab" role="tablist">
                                <li
                                    v-if="productData.rule !== null"
                                    class="nav-item"
                                    role="presentation"
                                >
                                    <button
                                        class="nav-link body-1 active"
                                        id="info-tab"
                                        data-bs-toggle="tab"
                                        data-bs-target="#info-tab-pane"
                                        type="button"
                                        role="tab"
                                        aria-controls="info-tab-pane"
                                        aria-selected="true"
                                    >
                                        Informação
                                    </button>
                                </li>

                                <li
                                    v-if="
                                        Object.hasOwn(
                                            productData.data,
                                            'description',
                                        )
                                    "
                                    class="nav-item"
                                    role="presentation"
                                >
                                    <button
                                        class="nav-link body-1"
                                        id="description-tab"
                                        data-bs-toggle="tab"
                                        data-bs-target="#description-tab-pane"
                                        type="button"
                                        role="tab"
                                        aria-controls="description-tab-pane"
                                        aria-selected="true"
                                    >
                                        Descrição
                                    </button>
                                </li>

                                <li
                                    v-if="
                                        Object.hasOwn(
                                            productData.data,
                                            'rulesofuse',
                                        )
                                    "
                                    class="nav-item"
                                    role="presentation"
                                >
                                    <button
                                        class="nav-link body-1"
                                        id="rulesofuse-tab"
                                        data-bs-toggle="tab"
                                        data-bs-target="#rulesofuse-tab-pane"
                                        type="button"
                                        role="tab"
                                        aria-controls="rulesofuse-tab-pane"
                                        aria-selected="false"
                                    >
                                        Regras de Uso
                                    </button>
                                </li>
                            </ul>

                            <!-- Nav Tab Content -->
                            <div class="tab-content" id="pdpTabContent">
                                <div
                                    v-if="productData.rule !== null"
                                    class="tab-pane fade show active"
                                    id="info-tab-pane"
                                    role="tabpanel"
                                    aria-labelledby="info-tab"
                                    tabindex="0"
                                >
                                    <!-- Office Info -->
                                    <ul class="list-group pdp-tab-info">
                                        <li class="pdp-tab-info-item">
                                            <p>Horário de Limpeza:</p>

                                            <p class="regular-weight">
                                                {{
                                                    `${productData.rule.clean.start} - ${productData.rule.clean.end}`
                                                }}
                                            </p>
                                        </li>

                                        <li class="pdp-tab-info-item">
                                            <p>Dias Encerrados:</p>

                                            <template
                                                v-if="
                                                    productData.rule
                                                        .weekdayclose.length ===
                                                    0
                                                "
                                            >
                                                <p class="regular-weight">
                                                    Disponível todos os dias
                                                    para Locação
                                                </p>
                                            </template>

                                            <template v-else>
                                                <p class="regular-weight">
                                                    {{
                                                        weekDayClose.join(", ")
                                                    }}
                                                </p>
                                            </template>
                                        </li>
                                    </ul>

                                    <!-- Accessories -->
                                    <div class="pdp-tab-accessories">
                                        <p>Acessórios:</p>

                                        <div class="pdp-list-accessories">
                                            <div
                                                v-for="(
                                                    valaccessorie,
                                                    indexaccessorie
                                                ) in productData.accessorie_id"
                                                :key="valaccessorie.id"
                                                :data-id="valaccessorie.id"
                                                :data-refereindex="
                                                    indexaccessorie
                                                "
                                                class="pdp-list-accessories-item"
                                            >
                                                <img
                                                    :src="
                                                        valaccessorie.data[0]
                                                            .url
                                                    "
                                                    :alt="
                                                        valaccessorie.data[0]
                                                            .name
                                                    "
                                                />

                                                <p class="regular-weight">
                                                    {{ valaccessorie.name }}
                                                </p>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Categories -->
                                    <div class="pdp-tab-categories">
                                        <p>Espaço adequado para:</p>

                                        <div class="pdp-list-categories">
                                            <div
                                                v-for="(
                                                    value, index
                                                ) in productData.category_id"
                                                :key="value.id"
                                                :data-id="value.id"
                                                :data-refereindex="index"
                                                class="pdp-list-categories-item"
                                            >
                                                <img
                                                    :src="value.icon_url"
                                                    :alt="value.name"
                                                />

                                                <p
                                                    class="button-body regular-weight"
                                                >
                                                    {{ value.name }}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div
                                    v-if="
                                        Object.hasOwn(
                                            productData.data,
                                            'description',
                                        )
                                    "
                                    class="tab-pane fade"
                                    id="description-tab-pane"
                                    role="tabpanel"
                                    aria-labelledby="description-tab"
                                    tabindex="0"
                                >
                                    {{ productData.data.description }}
                                </div>

                                <div
                                    v-if="
                                        Object.hasOwn(
                                            productData.data,
                                            'rulesofuse',
                                        )
                                    "
                                    class="tab-pane fade"
                                    id="rulesofuse-tab-pane"
                                    role="tabpanel"
                                    aria-labelledby="rulesofuse-tab"
                                    tabindex="0"
                                >
                                    {{ productData.data.rulesofuse }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Sidebar -->
            <aside class="sidebar-pdp">
                <div class="sidebar-base">
                    <!-- Header -->
                    <header class="sidebar-header">
                        <div class="base-header">
                            <h6>
                                {{ productData.value
                                }}<span class="caption-lg"> /hora</span>
                            </h6>
                            <p class="caption-md">*IVA incluído</p>
                        </div>
                    </header>

                    <!-- Content -->
                    <div class="sidebar-content">
                        <!-- Calendar -->
                        <div class="calendar-content">
                            <div
                                @click="showModal('modalcalendar')"
                                class="calendar-button"
                            >
                                <p
                                    role="button"
                                    id="search-date"
                                    class="text-start search-date"
                                    aria-label="Select date"
                                    @click="showModal('modalcalendar')"
                                >
                                    {{ reservedate }}
                                </p>
                            </div>

                            <div
                                @click="getHourOrPeriodForReserve($event)"
                                class="basebtnturn disabledclick"
                            ></div>
                        </div>

                        <hr />

                        <!-- Booking Details -->
                        <div class="list-content">
                            <p class="title-sidebar-section">
                                Detalhes da reserva:
                            </p>

                            <ul
                                @click="pdpActions($event)"
                                class="list-group detail-reserve-list"
                                ref="detailreservelist"
                            ></ul>
                        </div>

                        <!-- Add Day -->
                        <div
                            @click="showModal('addnewdaymodal')"
                            role="button"
                            class="addday disabledclick"
                        >
                            <span class="span-plus-icon">+</span>
                            <p class="adddaybtn disabledclick button-body">
                                Adicionar dia
                            </p>
                        </div>

                        <hr />

                        <!-- Total -->
                        <div class="pdp-total">
                            <div class="pdp-total-info d-flex flex-column">
                                <p class="color-text-body">Total:</p>
                                <h5 class="neutral-800">{{ total }} €</h5>
                            </div>

                            <button
                                @click="sendBooking()"
                                type="button"
                                class="btn-filled-blue button-body"
                                :disabled="disabled"
                                :class="{ disabled: disabled }"
                            >
                                Reservar
                            </button>
                        </div>
                    </div>
                </div>
            </aside>
        </div>

        <!-- Calendar Modal -->
        <modal
            title=""
            classname="modalcalendar"
            :hidemodalfunction="hideModal"
            indicate="pdp"
        >
            <template #modalcontent>
                <div class="d-flex flex-column">
                    <div class="d-flex flex-column search-type-base">
                        <p
                            class="text-start strong-600"
                            id="calendarModalLabel"
                        >
                            Tipo de Reserva
                        </p>

                        <div class="select-wrapper">
                            <select
                                @change="getReserveType($event)"
                                class="form-select select-search button-body"
                                name="search-type"
                                id="search-type"
                            >
                                <option
                                    v-for="(valtype, index) in customData
                                        .calendardata.typeofreservation"
                                    :key="index"
                                    :value="index"
                                    class="button-body"
                                    :selected="
                                        parseInt(reserveData.searchtype) ===
                                        parseInt(index)
                                    "
                                >
                                    {{ valtype }}
                                </option>
                            </select>
                            <span class="caldendar-icon"></span>
                        </div>
                    </div>

                    <calendar-element
                        classnamebase="d-flex flex-column"
                        :calendardata="customData.calendardata"
                        tdclassname="weekday"
                        @select_date="dynamicGetSelectDate($event, 'default')"
                        :allmonths="customData.calendardata.allmonths"
                        @clean_data="cleanOldData($event)"
                    />

                    <div class="modal-footer">
                        <button
                            @click="selectReserveDays('modalcalendar')"
                            type="button"
                            class="btn btn-primary btnselectday btn-filled-blue w-100 button-body"
                            id="select-day"
                            data-bs-dismiss="modal"
                            disabled
                        >
                            Escolher Dia
                        </button>

                        <button
                            @click="hideModal('modalcalendar')"
                            type="button"
                            class="btn btn-cancel w-100 button-body"
                            data-bs-dismiss="modal"
                        >
                            Cancelar
                        </button>
                    </div>
                </div>
            </template>
        </modal>

        <!-- Pdp Edit Modal -->
        <modal
            title=""
            classname="pdpeditmodal"
            :hidemodalfunction="hideModal"
            indicate="pdp"
        >
            <template #modalcontent>
                <div class="modal-body-flex-wrapper">
                    <h6 class="">Editar dia {{ pdpedit.day }}</h6>

                    <div class="flex-wrapper-class">
                        <p>Período</p>

                        <div
                            @click="editReservePerTurn($event)"
                            class="pdpeditturns"
                        ></div>
                    </div>

                    <div class="pdp-edit-modal-btns">
                        <button
                            @click="modalButtonsAction($event)"
                            type="button"
                            data-action="confirm"
                            :data-id="pdpedit.id"
                            class="btn btn-confirm button-body"
                        >
                            Confirmar
                        </button>

                        <button
                            @click="modalButtonsAction($event)"
                            type="button"
                            data-action="remove"
                            :data-id="pdpedit.id"
                            class="btn btn-remove-day button-body"
                        >
                            Eliminar dia
                        </button>

                        <button
                            @click="modalButtonsAction($event)"
                            type="button"
                            data-action="cancel"
                            :data-id="pdpedit.id"
                            class="btn btn-cancel button-body"
                        >
                            Cancelar
                        </button>
                    </div>
                </div>
            </template>
        </modal>

        <!-- Add New Day Modal -->
        <modal
            title=""
            classname="addnewdaymodal"
            :hidemodalfunction="hideModal"
            indicate="pdp"
        >
            <template #modalcontent>
                <div class="flex-wrapper-class">
                    <div class="addnewdaymodal-item search-period-wrapper">
                        <div
                            @click="getHourOrPeriodForAddNewDayReserve($event)"
                            class="addnewdaychooselist"
                        ></div>
                    </div>

                    <div class="addnewdaymodal-item search-type-base">
                        <p
                            id="calendarModalLabel"
                            class="text-start strong-600"
                        >
                            Escolher Dia
                        </p>
                    </div>

                    <calendar-element
                        classnamebase="addnewdaymodal-item"
                        :calendardata="customData.calendardata"
                        tdclassname="addnewweekday"
                        @select_date="dynamicGetSelectDate($event, 'newday')"
                        :allmonths="customData.calendardata.allmonths"
                        calendartype="newday"
                    />

                    <div
                        class="addnewdaymodal-item search-modal-action-btns modal-footer"
                    >
                        <button
                            @click="addNewDay()"
                            type="button"
                            class="btn btn-confirm btnaddnewday btn-filled-blue w-100 button-body"
                            id="addnew-day"
                            data-bs-dismiss="modal"
                            disabled
                        >
                            Escolher Dia
                        </button>

                        <button
                            @click="hideModal('addnewdaymodal')"
                            type="button"
                            class="btn btn-cancel w-100 button-body"
                            data-bs-dismiss="modal"
                        >
                            Cancelar
                        </button>
                    </div>
                </div>
            </template>
        </modal>

        <!-- Response Messages -->
        <div
            @click="closeMessageBox($event)"
            class="responsebasemessage"
            ref="responsebasemessage"
        >
            <list-message />
        </div>
    </div>
</template>

<script>
import Modal from "./../../elements/ModalElement.vue";
import Table from "./../../elements/TableElement.vue";
import calendarRoutine from "./../../../calendarScript.js";
import htmlElements from "../../../htmlElements.js";
import Loading from "../../elements/LoadingElement.vue";
import fetchData from "../../../fetchData.js";
import ListMessage from "./../../elements/ListMessageElement.vue";
import responseMessage from "./../../../responseMessage.js";
import CalendarElement from "../../elements/CalendarElement.vue";

//Set Use Strict
("use strict");

export default {
    name: "PDP",
    props: {
        productdata: {
            type: String,
            required: true,
        },
        customdata: {
            type: String,
            required: true,
        },
        bookingurl: {
            type: String,
            required: true,
        },
        csrftolken: {
            type: String,
            required: true,
        },
    },
    data: () => {
        return {
            productData: {},
            customData: {},
            mediaData: {},
            currentMonthNumber: "",
            reserveData: {
                city: "",
                month: "",
                year: "",
                searchtype: 1,
                reserver: {},
                filterbymonth: [],
                turndata: {
                    type: "",
                    datahour: {
                        begin: "",
                        end: "",
                    },
                    data: {},
                },
                editvalues: [],
                addnewdaylist: [],
            },
            daysElementsList: [],
            interval: [],
            customDays: [],
            reservedate: "dd-mm-yyyy",
            total: 0,
            disabled: true,
            pdpedit: {},
            addnewday: {
                reserver: {},
                searchtype: 1,
                turndata: {
                    type: "",
                    datahour: {
                        begin: "",
                        end: "",
                    },
                    data: {},
                },
            },
            defaulttypeofreserves: ["days", "interval", "customdays", "day"],
            activeclass: "d-flex",
            availableHour: true,
            pdpimage: [],
            weekDayClose: [],
            turnWeightValue: 2,
        };
    },
    created() {
        //Set Data
        this.productData = JSON.parse(this.productdata);
        this.customData = this.customdata ? JSON.parse(this.customdata) : null;

        Object.assign(this.mediaData, this.productData.media_data);

        //Get the First Pdp Image
        this.pdpimage =
            Object.values(this.mediaData).length > 0 ? this.mediaData[0] : "";

        //Get WeekDayClose
        if (this.productData.rule.weekdayclose.length > 0) {
            this.productData.rule.weekdayclose.forEach((value) =>
                this.weekDayClose.push(value.name),
            );
        }
    },
    mounted() {
        //Set Append Element Conditional
        this.appendElementConditional(
            this.productData.rule.typeofreservation.unique_reservation,
            "basebtnturn",
            "select-turn-morning-pdpbase",
            "select-turn-affternoon-pdpbase",
            "list-btnturn-pdpbase",
        );
        this.appendElementConditional(
            this.productData.rule.typeofreservation.unique_reservation,
            "pdpeditturns",
            "select-turn-morning-pdpedit",
            "select-turn-affternoon-pdpedit",
            "list-btnturn-pdpedit",
        );
        this.appendElementConditional(
            this.productData.rule.typeofreservation.unique_reservation,
            "addnewdaychooselist",
            "select-turn-morning-addnewday",
            "select-turn-affternoon-addnewday",
            "list-btnturn-addnewday",
        );

        //Set Current Month Number
        let dateStructure = new Date();

        //Set Default Reserve Data
        this.reserveData.month = dateStructure.getMonth() + 1;
        this.reserveData.year = dateStructure.getFullYear();

        //Set Values from Search Result in Booking Details
        this.setBookingDetailsFromSearchResult(this.customData.searchdata);
    },
    methods: {
        setReserveDateTextContent(reservedata, multiplereservedata) {
            return multiplereservedata.length > 0
                ? calendarRoutine.searchContentMultipleMonths(
                      multiplereservedata,
                  )
                : calendarRoutine.searchContent(
                      reservedata,
                      reservedata.month,
                      reservedata.year,
                  );
        },
        cleanOldData(data) {
            this.interval = data;
            this.customDays = data;
        },
        closeMessageBox(element) {
            responseMessage.closeBox(element.target);
        },
        changePdpImage(element) {
            //Get Media Id
            let mediaId = element.target.getAttribute("data-referindex");

            //Set Image
            this.pdpimage = Object.values(this.mediaData).find(
                (value, index) => index === parseInt(mediaId),
            );
        },
        checkPdpImage(imagedata) {
            return imagedata.thumbexist
                ? imagedata.media_thumb
                : imagedata.media_original;
        },
        turnBack() {
            return window.history.back();
        },
        addressStructure(pdpdata) {
            //Check Data
            let address = Object.hasOwn(pdpdata.data, "address")
                ? pdpdata.data.address
                : "";
            let postalcode = Object.hasOwn(pdpdata.data, "postalcode")
                ? pdpdata.data.postalcode
                : "";
            let complement = Object.hasOwn(pdpdata.data, "complement")
                ? ", " + pdpdata.data.complement + " "
                : "";

            return `${address}${complement}, ${postalcode} - ${pdpdata.location_name}`;
        },
        showModal(classname) {
            //Check Modal
            switch (classname) {
                //Calendar
                case "modalcalendar":
                    //Select Day Logic - Remove Class
                    [...document.querySelectorAll(".weekday")].forEach(
                        (value) => {
                            //Remove Class
                            value.firstElementChild.classList.remove(
                                "selectday",
                            );
                        },
                    );

                    //Disable Select
                    document
                        .querySelector(".basebtnturn")
                        .classList.add("disabledclick");

                    //Check Reserve Data
                    if (Object.values(this.reserveData.reserver).length === 0) {
                        //Disable Button Add New Modal
                        document
                            .querySelector(".adddaybtn")
                            .classList.add("disabledclick");
                        document
                            .querySelector(".addday")
                            .classList.add("disabledclick");
                    }

                    //Set Copy for period select
                    if (document.getElementById("list-btnturn-pdpbase")) {
                        document.getElementById(
                            "list-btnturn-pdpbase",
                        ).textContent = "Período";

                        //Remove active class from btnturn
                        calendarRoutine.removeActiveClassFromBtnTurn();
                    }

                    break;

                //Add New Day
                case "addnewdaymodal":
                    //Clean Old Data
                    this.addnewday.reserver = {};

                    //Select Day Logic - Remove Class
                    [...document.querySelectorAll(".addnewweekday")].forEach(
                        (value) => {
                            //Remove Class
                            value.firstElementChild.classList.remove(
                                "selectday",
                            );
                        },
                    );

                    //Default Values
                    if (
                        document.getElementById(
                            "select-turn-morning-addnewday",
                        ) &&
                        document.getElementById(
                            "select-turn-affternoon-addnewday",
                        )
                    ) {
                        //Clean Old Values
                        document.getElementById(
                            "refer-value-select-turn-morning-addnewday",
                        ).textContent = "Inicio";
                        document.getElementById(
                            "refer-value-select-turn-affternoon-addnewday",
                        ).textContent = "Fim";
                    }

                    //Clean Old data
                    this.addnewday.turndata.datahour.begin = "";
                    this.addnewday.turndata.datahour.end = "";

                    //Set Copy for period select
                    if (document.getElementById("list-btnturn-addnewday")) {
                        document.getElementById(
                            "list-btnturn-addnewday",
                        ).textContent = "Período";

                        //Remove active class from btnturn
                        calendarRoutine.removeActiveClassFromBtnTurn(
                            "addnewdaychooselist",
                        );
                    }

                    //Disable Button
                    document
                        .querySelector(".btnaddnewday")
                        .setAttribute("disabled", true);

                    break;
            }

            //Disabled Booking Button
            this.disabled = true;

            //Hide All Custom Selects
            if (
                document.querySelector(".firstdivbasevaluelist") &&
                document.querySelector(".seconddivbasevaluelist")
            ) {
                document
                    .querySelector(".firstdivbasevaluelist")
                    .classList.add("d-none");
                document
                    .querySelector(".seconddivbasevaluelist")
                    .classList.add("d-none");
            }

            //Show Modal
            $(`.${classname}`).modal("show");
        },
        hideModal(classname) {
            //Get Object Keys
            let reserverlisttype = Object.getOwnPropertyNames(
                this.reserveData.reserver,
            );

            //Valid Reserve Key
            let validKey = reserverlisttype.find((value) =>
                this.defaulttypeofreserves.includes(value),
            );

            //Check Reserve Data for Enabled Booking Button
            if (
                (Array.isArray(this.reserveData.reserver[validKey]) &&
                    this.reserveData.reserver[validKey].length > 0) ||
                this.reserveData.reserver[validKey] !== ""
            ) {
                //Get All Booking Details Elements
                let bookingListElement = [
                    ...document.querySelector(".detail-reserve-list").children,
                ];
                let noavailable = bookingListElement.find((value) =>
                    value.classList.contains("noavailable"),
                );

                //Enabled Booking Button
                this.disabled = false;

                //Check Available Hour for Booking
                if (!this.availableHour || noavailable !== undefined) {
                    this.disabled = true;
                }
            }

            //Hide Modal
            $(`.${classname}`).modal("hide");
        },
        appendElementConditional(
            typeoflocation,
            baseelement,
            firstselect = "select-turn-morning",
            secondselect = "select-turn-affternoon",
            selectTurnIdName,
        ) {
            //Create Append Calendar Element
            calendarRoutine.createAppendElement(
                typeoflocation,
                baseelement,
                firstselect,
                secondselect,
                this.productData.rule.typeofreservation
                    .periodic_reserve_conditional.allturns[0].begin,
                this.productData.rule.typeofreservation
                    .periodic_reserve_conditional.allturns[1].begin,
                this.productData.rule.typeofreservation
                    .periodic_reserve_conditional.block_of_hour,
                selectTurnIdName,
            );
        },
        getReserveType(element) {
            //Disable BTN
            document
                .querySelector(".btnselectday")
                .setAttribute("disabled", true);

            //Clean Old Filter Select
            this.reserveData.reserver = {};
            this.addnewday.reserver = {};
            this.reserveData.filterbymonth = [];

            //Clean Old Edit Values
            this.reserveData.editvalues = [];
            this.reserveData.addnewdaylist = [];

            //Clean Old List
            this.interval = [];
            this.customDays = [];

            //Select Day Logic - Remove Class
            [...document.querySelectorAll(".weekday")].forEach((value) => {
                //Remove Class
                value.firstElementChild.classList.remove("selectday");
            });

            //Remove old Booking Details
            [...this.$refs.detailreservelist.children].forEach((value) =>
                value.remove(),
            );

            //Clean Old Total Value
            this.total = 0;

            //Change Select Hour or Period for Default Values
            switch (
                this.productData.rule.typeofreservation.unique_reservation
            ) {
                //Reserve per Hour
                case 1:
                    //Clean Old Values
                    document.getElementById(
                        "refer-value-select-turn-morning-pdpbase",
                    ).textContent = "Inicio";
                    document.getElementById(
                        "refer-value-select-turn-affternoon-pdpbase",
                    ).textContent = "Fim";

                    //Clean Old data
                    this.reserveData.turndata.datahour.begin = "";
                    this.reserveData.turndata.datahour.end = "";

                    break;

                //Reserve per period
                case 2:
                    //Set Copy for period select
                    if (document.getElementById("list-btnturn-pdpbase")) {
                        document.getElementById(
                            "list-btnturn-pdpbase",
                        ).textContent = "Período";

                        //Remove active class from btnturn
                        calendarRoutine.removeActiveClassFromBtnTurn();
                    }

                    break;
            }

            //Set Search Type
            this.reserveData.searchtype = parseInt(element.target.value);
        },
        dynamicGetSelectDate(element, action) {
            switch (action) {
                case "newday":
                    this.getSelectDate(
                        element,
                        "btnaddnewday",
                        this.addnewday,
                        "addnewweekday",
                    );

                    break;

                case "default":
                    this.getSelectDate(
                        element,
                        "btnselectday",
                        this.reserveData,
                        "weekday",
                    );

                    break;
            }
        },
        getSelectDate(element, btnselect, reserverdata, trclassname) {
            //Check Element
            if (element.currentTarget.nodeName === "TD") {
                //Get All Dom Elements
                let spanElement = element.currentTarget.firstElementChild;
                let monthElement = element.currentTarget.offsetParent;

                //Check Day
                if (spanElement.textContent === "") {
                    return;
                }

                //Check Sunday Weekday
                if (
                    spanElement.offsetParent.getAttribute("data-weekday") ===
                    "Sunday"
                ) {
                    //Render Response Message
                    responseMessage.renderResponseMessages(
                        this.$refs.responsebasemessage,
                        "warning",
                        "Não é permitido a seleção do dia de semana indicado",
                        this.activeclass,
                    );

                    return;
                }

                //Disable BTN
                document
                    .querySelector(`.${btnselect}`)
                    .setAttribute("disabled", true);

                //Get All Td Values
                let daysElementMonthList =
                    calendarRoutine.getAllElementsDayFromMonthCalendar(
                        [...monthElement.children],
                        trclassname,
                    );

                //Select Days from Search Type
                calendarRoutine.dynamicStrucutureForSelectDaysFromSearchType(
                    reserverdata,
                    element.currentTarget,
                    spanElement,
                    daysElementMonthList,
                    this.interval,
                    this.customDays,
                    btnselect,
                    "reserver",
                );
            }
        },
        selectReserveDays(classmodalname) {
            //Set Booking Date TextContent
            this.reservedate = this.setReserveDateTextContent(
                this.reserveData.reserver,
                this.reserveData.filterbymonth,
            );

            //Enable Select
            document
                .querySelector(".basebtnturn")
                .classList.remove("disabledclick");

            //Hide Modal
            this.hideModal(classmodalname);
        },
        getHourOrPeriodForReserve(element) {
            //Check Base Element
            if (
                element.target.nodeName === "DIV" &&
                element.target.classList.contains("basebtnturn")
            ) {
                return;
            }

            //Check Element
            if (
                element.target.hasAttribute("data-action") &&
                element.target.getAttribute("data-action") === "list"
            ) {
                //Show period turns
                calendarRoutine.showHideTurnList(element.target);

                return;
            }

            //Get Element
            calendarRoutine.dynamicUpdateSelectTurnId(
                element.target,
                "list-btnturn-pdpbase",
            );

            //Check Element detail-reserve-list
            this.reserveData.turndata = calendarRoutine.setHourOrPeriod(
                this.reserveData.turndata,
                element.target,
            );

            //Remove old Booking Details
            [...this.$refs.detailreservelist.children].forEach((value) =>
                value.remove(),
            );

            //Get Object Keys
            let reserverlisttype = Object.getOwnPropertyNames(
                this.reserveData.reserver,
            );

            //Clean Old Total Value
            this.total = 0;

            //Booking Details Structure
            this.bookingDetailsStructure(this.reserveData, reserverlisttype);

            //Enable Button
            document
                .querySelector(".adddaybtn")
                .classList.remove("disabledclick");
            document.querySelector(".addday").classList.remove("disabledclick");

            //Set Total Structure
            this.total = parseFloat(this.total);

            //Enabled Booking Button
            this.disabled = false;

            //Check Available Hour for Booking
            if (!this.availableHour) {
                this.disabled = true;
            }
        },
        bookingDetailsStructure(reserverdata, reserverlisttype) {
            //Default Variables
            let begin = null;
            let end = null;
            let total = null;

            //Check Type of Location
            switch (
                this.productData.rule.typeofreservation.unique_reservation
            ) {
                //Reserve per hour
                case 1:
                    //Separate Datahour
                    begin = reserverdata.turndata.datahour.begin;
                    end = reserverdata.turndata.datahour.end;
                    total =
                        Number.isInteger(begin) && Number.isInteger(end)
                            ? parseInt(end - begin)
                            : null;

                    //Add Check Conditional for Hour Error
                    if (begin && end) {
                        if (
                            !calendarRoutine.checkValuesBeforeSend(
                                begin,
                                end,
                                "select-turn-morning-pdpbase",
                                "select-turn-affternoon-pdpbase",
                            )
                        ) {
                            //Render Response Message
                            responseMessage.renderResponseMessages(
                                this.$refs.responsebasemessage,
                                "danger",
                                "Por favor informar a hora de fim maior que a hora de início",
                                this.activeclass,
                            );

                            //Clean Variables
                            reserverdata.turndata.datahour.begin = "";
                            reserverdata.turndata.datahour.end = "";

                            return;
                        }
                    } else {
                        return;
                    }

                    //Add Booking Details
                    this.addBookingDetails(
                        begin,
                        end,
                        total,
                        reserverlisttype,
                        reserverdata,
                    );

                    break;

                //Reserve per period
                case 2:
                    //Separate Datahour
                    begin = this.getPerPeriodHourConditional(
                        reserverdata.turndata.data,
                    );

                    //Period Variable
                    let turnInfoCalculateValues = this.dynamicCalculateTurnData(
                        reserverdata.turndata.data,
                        begin
                    );

                    //Add Booking Details
                    this.addBookingDetails(
                        begin,
                        turnInfoCalculateValues.end,
                        turnInfoCalculateValues.total,
                        reserverlisttype,
                        reserverdata,
                    );

                    break;
            }
        },
        addBookingDetails(begin, end, total, reserverlisttype, reserverdata) {
            //Add Hour in Booking Details
            if (Number.isInteger(total) && total !== 0) {
                //Check negative number
                if (total > 0) {
                    //only for multiple months
                    if (
                        Object.hasOwn(reserverdata, "filterbymonth") &&
                        reserverdata.filterbymonth.length > 0
                    ) {
                        ["customdays", "days"].forEach((type) => {
                            reserverdata.filterbymonth.forEach((value) => {
                                if (Object.hasOwn(value, type)) {
                                    value[type].forEach((day) => {
                                        //Dynamic Create Booking Details
                                        this.total += this.setBookingDetails(
                                            begin,
                                            end,
                                            total,
                                            day,
                                            value.month,
                                            value.year,
                                        );
                                    });
                                }
                            });
                        });

                        return;
                    }

                    //Check Object Keys only for current month
                    reserverlisttype.forEach((value) => {
                        switch (value) {
                            //day
                            case "day":
                                //Dynamic Create Booking Details
                                this.total += this.setBookingDetails(
                                    begin,
                                    end,
                                    total,
                                    reserverdata.reserver[value],
                                    reserverdata.reserver.month,
                                    reserverdata.reserver.year,
                                );

                                break;

                            //days, interval, customdays
                            case "days":
                            case "interval":
                            case "customdays":
                                reserverdata.reserver[value].forEach(
                                    (value) => {
                                        //Dynamic Create Booking Details
                                        this.total += this.setBookingDetails(
                                            begin,
                                            end,
                                            total,
                                            value,
                                            this.reserveData.reserver.month,
                                            this.reserveData.reserver.year,
                                        );
                                    },
                                );

                                break;
                        }
                    });
                }
            }
        },
        setBookingDetails(begin, end, total, selectday, month, year) {
            //Set Sub Total Value
            let subtotalvalue = parseFloat(
                this.productData.value_number * total,
            );

            //Set SubTotal
            let subtotal = subtotalvalue + " €";

            //Set Day
            let day = `${selectday}-${month}-${year}`;

            //Check Available Hour
            this.availableHour = this.checkAvailableHour(
                selectday,
                begin,
                end,
                month,
                year,
            );

            //Append Li
            this.$refs.detailreservelist.appendChild(
                calendarRoutine.setBookingDetails(
                    subtotalvalue,
                    subtotal,
                    day,
                    begin,
                    end,
                    selectday,
                    total,
                    true,
                    this.availableHour,
                    month,
                    year,
                ),
            );

            return subtotalvalue;
        },
        checkAvailableHour(selectday, begin, end, month, year) {
            //Available Hour
            let available = true;

            //Check begin and end hour from Booking DataBase
            if (
                Object.hasOwn(this.customData.bookingdata, selectday) &&
                this.customData.bookingdata[selectday].month === month &&
                this.customData.bookingdata[selectday].year === year
            ) {
                if (Number.isInteger(begin) && Number.isInteger(end)) {
                    //Check Begin and End Hour
                    let notAvailableBeginHour =
                        this.customData.bookingdata[selectday].begin.includes(
                            begin,
                        );
                    let notAvailableEndHour =
                        this.customData.bookingdata[selectday].end.includes(
                            end,
                        );

                    //Available Hour
                    available =
                        notAvailableBeginHour || notAvailableEndHour
                            ? false
                            : true;

                    return available;
                }
            }

            return available;
        },
        setBookingDetailsFromSearchResult(searchData) {
            //Check Search Data when is made for filter
            if (searchData.length === 0) {
                //Get Data from Session Storage
                let searchdata = sessionStorage.getItem("search_data");

                //Check Session Storage
                if (!searchdata) {
                    return;
                }

                //Decode Search Data
                searchdata = JSON.parse(searchdata);

                //Set Reserve Date TextContent
                this.reservedate = this.setReserveDateTextContent(
                    searchdata.filter,
                    searchdata.filterbymonth,
                );

                //Set Search Data as Reserve Data
                Object.assign(this.reserveData.reserver, searchdata.filter);
                this.reserveData.filterbymonth = searchdata.filterbymonth;
                Object.assign(this.reserveData.turndata, searchdata.turndata);

                //Set Searchtype
                this.reserveData.searchtype = searchData.searchtype;

                //Clean Old Total Value
                this.total = 0;

                //Enable Select
                document
                    .querySelector(".basebtnturn")
                    .classList.remove("disabledclick");
            }

            //Check Search Data when exist
            if (searchData.length > 0) {
                //Decode Search Data
                searchData = JSON.parse(searchData);

                //Set Reserve Date TextContent
                this.reservedate = this.setReserveDateTextContent(
                    searchData.filter,
                    searchData.filterbymonth,
                );

                //Get Object Keys - REVER
                let reserverlisttype = Object.getOwnPropertyNames(
                    searchData.filter,
                );

                //Set Search Data as Reserve Data
                Object.assign(this.reserveData.reserver, searchData.filter);
                this.reserveData.filterbymonth = searchData.filterbymonth;
                Object.assign(this.reserveData.turndata, searchData.turndata);

                //Set Searchtype
                this.reserveData.searchtype = searchData.searchtype;

                //Clean Old Total Value
                this.total = 0;

                //Default Variables
                let begin = null;
                let end = null;
                let total = null;

                //Add Period or Hour Values from Search
                switch (searchData.typeoflocation) {
                    //Reserve per Hour
                    case 1:
                        //Check Elements
                        if (
                            !document.getElementById(
                                "refer-value-select-turn-morning-pdpbase",
                            ) &&
                            !document.getElementById(
                                "refer-value-select-turn-affternoon-pdpbase",
                            )
                        ) {
                            return;
                        }

                        //Clean Old Values
                        document.getElementById(
                            "refer-value-select-turn-morning-pdpbase",
                        ).textContent =
                            `${searchData.turndata.datahour.begin}:00`;
                        document.getElementById(
                            "refer-value-select-turn-affternoon-pdpbase",
                        ).textContent =
                            `${searchData.turndata.datahour.end}:00`;

                        //Clean Old data
                        this.reserveData.turndata.datahour.begin =
                            searchData.turndata.datahour.begin;
                        this.reserveData.turndata.datahour.end =
                            searchData.turndata.datahour.end;

                        //Separate Datahour
                        begin = this.reserveData.turndata.datahour.begin;
                        end = this.reserveData.turndata.datahour.end;
                        total =
                            Number.isInteger(begin) && Number.isInteger(end)
                                ? parseInt(end - begin)
                                : null;

                        //Add Booking Details
                        this.addBookingDetails(
                            begin,
                            end,
                            total,
                            reserverlisttype,
                            this.reserveData,
                        );

                        break;

                    //Reserve per period
                    case 2:
                        //Separate Datahour
                        begin = this.getPerPeriodHourConditional(
                            searchData.turndata.data,
                        );

                        //Period Variable
                        let turnInfoCalculateValues = this.dynamicCalculateTurnData(
                            searchData.turndata.data,
                            begin
                        );

                        let textIndicate = "";

                        //Set Default Values
                        [...document.querySelectorAll(".btnturn")].forEach(
                            (value) => {
                                if (
                                    parseInt(
                                        value.getAttribute("data-value"),
                                    ) === searchData.turndata.data
                                ) {
                                    value.classList.add("active");
                                    textIndicate = value.firstChild.textContent;

                                    return;
                                }

                                value.classList.remove("active");
                            },
                        );

                        //Set Copy for period select
                        if (document.getElementById("list-btnturn-pdpbase")) {
                            document.getElementById(
                                "list-btnturn-pdpbase",
                            ).textContent = textIndicate;
                        }

                        //Add Booking Details
                        this.addBookingDetails(
                            begin,
                            turnInfoCalculateValues.end,
                            turnInfoCalculateValues.total,
                            reserverlisttype,
                            this.reserveData,
                        );

                        break;
                }

                //Enable Select
                document
                    .querySelector(".basebtnturn")
                    .classList.remove("disabledclick");

                //Enable Add New Day Button
                document
                    .querySelector(".adddaybtn")
                    .classList.remove("disabledclick");
                document
                    .querySelector(".addday")
                    .classList.remove("disabledclick");

                //Set Total Structure
                this.total = parseFloat(this.total);

                //Enabled Booking Button
                this.disabled = false;

                //Check Available Hour for Booking
                if (!this.availableHour) {
                    this.disabled = true;
                }
            }
        },
        pdpActions(element) {
            //Check Element
            if (
                element.target.nodeName === "SPAN" &&
                element.target.classList.contains("edit-pdp-details")
            ) {
                //Get Att list from Booking Details
                let bookingDetailsList = [
                    ...this.$refs.detailreservelist.children,
                ];

                //Get Parent Li Element
                let bookingDetailElement = element.target.offsetParent;

                //Set Content for Edit
                this.pdpedit.id = bookingDetailsList.findIndex(
                    (value) => value === bookingDetailElement,
                );
                this.pdpedit.day = `${element.target.getAttribute(
                    "data-day",
                )}-${element.target.getAttribute(
                    "data-month",
                )}-${element.target.getAttribute("data-year")}`;
                this.pdpedit.turndata = {
                    type: "",
                    datahour: {
                        begin: "",
                        end: "",
                    },
                    data: {},
                };

                //Set Values for Edit
                switch (
                    this.productData.rule.typeofreservation.unique_reservation
                ) {
                    //Reserve per hour
                    case 1:
                        //Clean Old Values
                        document.getElementById(
                            "refer-value-select-turn-morning-pdpedit",
                        ).textContent = "Inicio";
                        document.getElementById(
                            "refer-value-select-turn-affternoon-pdpedit",
                        ).textContent = "Fim";
                        break;

                    //Reserve per period
                    case 2:
                        //Set Copy for period select
                        if (document.getElementById("list-btnturn-pdpedit")) {
                            document.getElementById(
                                "list-btnturn-pdpedit",
                            ).textContent = "Período";

                            //Remove active class from btnturn
                            calendarRoutine.removeActiveClassFromBtnTurn(
                                "pdpeditturns",
                            );
                        }

                        break;
                }

                //Show Modal
                this.showModal("pdpeditmodal");
            }
        },
        cleanSelectHourOrTurn(
            reservekey,
            reservemonthslist,
            listofdays,
            month,
            year,
        ) {
            if (reservekey === undefined && reservemonthslist.length === 0) {
                //Default Values
                if (
                    document.getElementById("select-turn-morning-pdpbase") &&
                    document.getElementById("select-turn-affternoon-pdpbase")
                ) {
                    //Clean Old Values
                    document.getElementById(
                        "refer-value-select-turn-morning-pdpbase",
                    ).textContent = "Inicio";
                    document.getElementById(
                        "refer-value-select-turn-affternoon-pdpbase",
                    ).textContent = "Fim";
                }

                //Set Default Values
                [...document.querySelectorAll(".btnturn")].forEach((value) =>
                    value.classList.remove("active"),
                );

                //Disable Select from Calendar Modal
                document
                    .querySelector(".basebtnturn")
                    .classList.add("disabledclick");

                //Set default Value
                this.reservedate =
                    listofdays.days.length > 0
                        ? calendarRoutine.searchContent(listofdays, month, year)
                        : "dd-mm-yyyy";
            }
        },
        modalButtonsAction(element) {
            //Get Att list from Booking Details
            let bookingDetailsList = [...this.$refs.detailreservelist.children];

            //Get Booking Detail Id
            let bookingDetailElementId = element.target.getAttribute("data-id");

            //Get Day from Element
            let day = [...this.$refs.detailreservelist.children].find(
                (value, index) => index === parseInt(bookingDetailElementId),
            );
            let month =
                day !== undefined
                    ? parseInt(day.getAttribute("data-month"))
                    : null;
            let year =
                day !== undefined
                    ? parseInt(day.getAttribute("data-year"))
                    : null;

            //Edit Variables
            let editValues = {};

            //Button Actions
            switch (element.target.getAttribute("data-action")) {
                //Confirm Changes
                case "confirm":
                    //Set Values from Pdp Edit
                    switch (
                        this.productData.rule.typeofreservation
                            .unique_reservation
                    ) {
                        //Reserve per hour
                        case 1:
                            //Edit Values
                            editValues = {
                                id: parseInt(bookingDetailElementId),
                                day: this.pdpedit.day,
                                month: month,
                                year: year,
                                begin: this.pdpedit.turndata.datahour.begin,
                                end: this.pdpedit.turndata.datahour.end,
                                totalhour:
                                    this.pdpedit.turndata.datahour.end -
                                    this.pdpedit.turndata.datahour.begin,
                                subtotal: parseFloat(
                                    this.productData.value_number *
                                        (this.pdpedit.turndata.datahour.end -
                                            this.pdpedit.turndata.datahour
                                                .begin),
                                ),
                                turndata: null,
                            };

                            //Add Check Conditional for Hour Error
                            if (editValues.begin && editValues.end) {
                                if (
                                    !calendarRoutine.checkValuesBeforeSend(
                                        editValues.begin,
                                        editValues.end,
                                        "select-turn-morning-pdpedit",
                                        "select-turn-affternoon-pdpedit",
                                    )
                                ) {
                                    //Render Response Message
                                    responseMessage.renderResponseMessages(
                                        this.$refs.responsebasemessage,
                                        "danger",
                                        "Por favor informar a hora de fim maior que a hora de início",
                                        this.activeclass,
                                    );

                                    return;
                                }
                            } else {
                                //Render Response Message
                                responseMessage.renderResponseMessages(
                                    this.$refs.responsebasemessage,
                                    "warning",
                                    "Por favor informar dados válidos",
                                    this.activeclass,
                                );

                                return;
                            }

                            //Set Total Hours Base
                            let totalhoursbase =
                                this.reserveData.turndata.datahour.end -
                                this.reserveData.turndata.datahour.begin;

                            //Get Current New Day
                            let currentNewDay =
                                this.reserveData.addnewdaylist.find(
                                    (value) =>
                                        value.reserver.day ===
                                        parseInt(day.getAttribute("data-day")),
                                );

                            //Check Add New Day List
                            if (currentNewDay !== undefined) {
                                //Set Total Hours Base
                                totalhoursbase =
                                    currentNewDay.turndata.datahour.end -
                                    currentNewDay.turndata.datahour.begin;

                                //Att New Value
                                this.reserveData.addnewdaylist.map((value) => {
                                    if (value.reserver.day === editValues.day) {
                                        value.turndata.datahour.end =
                                            editValues.end;
                                        value.turndata.datahour.begin =
                                            editValues.begin;
                                    }
                                });
                            }

                            //Check Available Hour
                            this.availableHour = this.checkAvailableHour(
                                parseInt(
                                    editValues.day.replace(
                                        `-${editValues.month}-${editValues.year}`,
                                        "",
                                    ),
                                ),
                                editValues.begin,
                                editValues.end,
                                editValues.month,
                                editValues.year,
                            );

                            //Set Edit Values
                            this.reserveData.editvalues =
                                this.recalculateTotalAndPushEditVaulues(
                                    bookingDetailElementId,
                                    this.reserveData.editvalues,
                                    editValues,
                                    totalhoursbase,
                                );

                            //Change Values in Booking List
                            this.setBookingDetailEditElement(
                                bookingDetailsList,
                                bookingDetailElementId,
                                editValues,
                            );

                            //Hide Modal
                            this.hideModal("pdpeditmodal");

                            break;

                        //Reserve per period
                        case 2:
                            //Hour Structure
                            let beginstructure =
                                this.getPerPeriodHourConditional(
                                    this.pdpedit.turndata.data,
                                );

                            //Check Begin Hour
                            if (beginstructure === null) {
                                //Render Response Message
                                responseMessage.renderResponseMessages(
                                    this.$refs.responsebasemessage,
                                    "warning",
                                    "Por favor informar dados válidos",
                                    this.activeclass,
                                );

                                return;
                            }

                            //Period Variable
                            let turnInfoCalculateValues = this.dynamicCalculateTurnData(
                                this.pdpedit.turndata.data,
                                beginstructure,
                                this.productData.rule.typeofreservation.periodic_reserve_conditional.block_of_hour
                            );
                          
                            //Edit Values
                            editValues = {
                                id: parseInt(bookingDetailElementId),
                                day: this.pdpedit.day,
                                month: month,
                                year: year,
                                begin: beginstructure,
                                end: turnInfoCalculateValues.end,
                                totalhour: turnInfoCalculateValues.total,
                                subtotal: parseFloat(
                                    this.productData.value_number *
                                        turnInfoCalculateValues.total,
                                ),
                                turndata: this.pdpedit.turndata,
                            };

                            //Check Available Hour
                            this.availableHour = this.checkAvailableHour(
                                parseInt(
                                    editValues.day.replace(
                                        `-${editValues.month}-${editValues.year}`,
                                        "",
                                    ),
                                ),
                                editValues.begin,
                                editValues.end,
                                editValues.month,
                                editValues.year,
                            );

                            //Set Edit Values
                            this.reserveData.editvalues =
                                this.recalculateTotalAndPushEditVaulues(
                                    bookingDetailElementId,
                                    this.reserveData.editvalues,
                                    editValues,
                                    turnInfoCalculateValues.blockofhour,
                                );

                            //Change Values in Booking List
                            this.setBookingDetailEditElement(
                                bookingDetailsList,
                                bookingDetailElementId,
                                editValues,
                            );

                            //Hide Modal
                            this.hideModal("pdpeditmodal");

                            break;
                    }

                    break;

                //Remove Booking Detail
                case "remove":
                    //Confirm Remove
                    let confirmRemove = confirm(
                        `Deseja remover o dia ${this.pdpedit.day} ?`,
                    );

                    if (!confirmRemove) {
                        return;
                    }

                    //Get Edit Value Element
                    let bookingDetailEditElement =
                        this.reserveData.editvalues.find(
                            (value) =>
                                value.id === parseInt(bookingDetailElementId),
                        );

                    //Remove Edit Value from Add New Value List
                    let reserveDayIndex =
                        this.reserveData.addnewdaylist.findIndex(
                            (valday) =>
                                valday.reserver.day ===
                                parseInt(day.getAttribute("data-day")),
                        );

                    //Remove from Add new Value List
                    if (reserveDayIndex !== -1) {
                        this.reserveData.addnewdaylist.splice(
                            reserveDayIndex,
                            1,
                        );
                    }

                    //Check if the edit value exist and Recalculate Total
                    if (bookingDetailEditElement !== undefined) {
                        //Remove Edit Value from Edit Value List
                        let bookingDetailEditElementIndex =
                            this.reserveData.editvalues.findIndex(
                                (value) =>
                                    value.id ===
                                    parseInt(bookingDetailElementId),
                            );

                        this.reserveData.editvalues.splice(
                            bookingDetailEditElementIndex,
                            1,
                        );

                        //Recalculate Total
                        this.total =
                            this.total - bookingDetailEditElement.subtotal;
                    } else {
                        //Recalculate Total
                        this.total =
                            this.total -
                            parseFloat(day.getAttribute("data-total"));
                    }

                    //Create List of Days
                    let listofdays = {
                        days: [],
                    };

                    //Set Days from Add New Days List
                    if (this.reserveData.addnewdaylist.length > 0) {
                        this.reserveData.addnewdaylist.forEach((value) => {
                            listofdays.days.push(value.reserver.day);
                        });
                    }

                    //Only for Multiple Reserves for each Months
                    if (this.reserveData.filterbymonth.length > 0) {
                        let indexReserveDataMonths = [];

                        ["customdays", "days"].forEach((value) => {
                            this.reserveData.filterbymonth.forEach(
                                (reserve, index) => {
                                    if (
                                        Array.isArray(reserve[value]) &&
                                        reserve[value].includes(
                                            parseInt(
                                                day.getAttribute("data-day"),
                                            ),
                                        ) &&
                                        month === reserve.month &&
                                        year === reserve.year
                                    ) {
                                        if (reserve[value].length === 1) {
                                            indexReserveDataMonths.push(index);
                                        } else {
                                            let dayindex = reserve[
                                                value
                                            ].indexOf(
                                                parseInt(
                                                    day.getAttribute(
                                                        "data-day",
                                                    ),
                                                ),
                                            );
                                            reserve[value].splice(dayindex, 1);
                                        }
                                    }
                                },
                            );
                        });

                        //Remove data from filterbymonth list
                        if (indexReserveDataMonths.length > 0) {
                            indexReserveDataMonths.forEach((value) =>
                                this.reserveData.filterbymonth.splice(value, 1),
                            );
                        }

                        this.reservedate =
                            this.reserveData.filterbymonth.length > 0
                                ? calendarRoutine.searchContentMultipleMonths(
                                      this.reserveData.filterbymonth,
                                  )
                                : "dd-mm-yyyy";
                    } else {
                        //Get Object Keys
                        let reserverlisttype = Object.getOwnPropertyNames(
                            this.reserveData.reserver,
                        );

                        //Remove From Reserve Data Reserve
                        reserverlisttype.forEach((value) => {
                            switch (value) {
                                //day
                                case "day":
                                    //Check Day alreay exist in Reserve Data
                                    if (
                                        parseInt(
                                            day.getAttribute("data-day"),
                                        ) === this.reserveData.reserver[value]
                                    ) {
                                        //Remove Object Data
                                        delete this.reserveData.reserver[value];

                                        //Set default Value
                                        this.reservedate =
                                            listofdays.days.length > 0
                                                ? calendarRoutine.searchContent(
                                                      listofdays,
                                                      month,
                                                      year,
                                                  )
                                                : "dd-mm-yyyy";
                                    } else {
                                        //Check List of Days
                                        if (listofdays.days.length > 0) {
                                            listofdays.days.unshift(
                                                this.reserveData.reserver[
                                                    value
                                                ],
                                            );
                                            listofdays.days.sort(
                                                (a, b) => a - b,
                                            );
                                        }

                                        //Set default Value
                                        this.reservedate =
                                            listofdays.days.length > 0
                                                ? calendarRoutine.searchContent(
                                                      listofdays,
                                                      month,
                                                      year,
                                                  )
                                                : `${this.reserveData.reserver[value]}-${this.reserveData.reserver.month}-${this.reserveData.reserver.year}`;
                                    }

                                    break;

                                //days, interval, customdays
                                case "days":
                                case "interval":
                                case "customdays":
                                    //Check Reserve Day List
                                    if (
                                        this.reserveData.reserver[value]
                                            .length === 1
                                    ) {
                                        //Remove Object Data
                                        delete this.reserveData.reserver[value];

                                        //Set default Value
                                        this.reservedate =
                                            listofdays.days.length > 0
                                                ? calendarRoutine.searchContent(
                                                      listofdays,
                                                      month,
                                                      year,
                                                  )
                                                : "dd-mm-yyyy";
                                    } else {
                                        //Get Index from Day
                                        let reserveDayIndex =
                                            this.reserveData.reserver[
                                                value
                                            ].findIndex(
                                                (valday) =>
                                                    valday ===
                                                    parseInt(
                                                        day.getAttribute(
                                                            "data-day",
                                                        ),
                                                    ),
                                            );

                                        //Reserve Day from Reserve List
                                        this.reserveData.reserver[value].splice(
                                            reserveDayIndex,
                                            1,
                                        );

                                        //Check List of Days
                                        if (
                                            this.reserveData.reserver[value]
                                                .length > 0
                                        ) {
                                            listofdays.days =
                                                listofdays.days.length > 0
                                                    ? listofdays.days.concat(
                                                          this.reserveData
                                                              .reserver[value],
                                                      )
                                                    : this.reserveData.reserver[
                                                          value
                                                      ];
                                            listofdays.days.sort(
                                                (a, b) => a - b,
                                            );
                                        }

                                        //Set default Value
                                        this.reservedate =
                                            calendarRoutine.searchContent(
                                                listofdays,
                                                month,
                                                year,
                                            );
                                    }

                                    break;
                            }
                        });
                    }

                    //Check the reserve data key object
                    let reserveKeyObject = Object.keys(
                        this.reserveData.reserver,
                    ).find((valkey) =>
                        this.defaulttypeofreserves.includes(valkey),
                    );

                    //Add Data for Input when Reserve is empty
                    this.cleanSelectHourOrTurn(
                        reserveKeyObject,
                        this.reserveData.filterbymonth,
                        listofdays,
                        month,
                        year,
                    );

                    //Remove Booking Detail Element from List
                    bookingDetailsList.forEach((value, index) => {
                        if (index === parseInt(bookingDetailElementId)) {
                            value.remove();
                        }
                    });

                    //Select Day Logic - Remove Class
                    [...document.querySelectorAll(".weekday")].forEach(
                        (value) => {
                            if (
                                day.getAttribute("data-day") ===
                                value.firstElementChild.textContent
                            ) {
                                //Remove Class
                                value.firstElementChild.classList.remove(
                                    "selectday",
                                );
                            }
                        },
                    );

                    //Hide Modal
                    this.hideModal("pdpeditmodal");

                    break;

                //Cancel Edit
                case "cancel":
                    //Hide Modal
                    this.hideModal("pdpeditmodal");

                    break;
            }
        },
        setBookingDetailEditElement(
            bookingDetailsList,
            bookingDetailElementId,
            editValues,
        ) {
            //Change Values in Booking List
            bookingDetailsList.forEach((value, index) => {
                if (parseInt(bookingDetailElementId) === index) {
                    //Available Hour Conditional - Remove noavailable
                    if (
                        this.availableHour &&
                        value.classList.contains("noavailable")
                    ) {
                        value.classList.remove("noavailable");
                    }

                    //Available Hour Conditional - Add noavailable
                    if (!this.availableHour) {
                        value.classList.add("noavailable");
                    }

                    //Get Div Elements
                    let firstdiv = value.firstElementChild;
                    let seconddiv = value.lastElementChild;

                    //Get the Hour Element
                    let hourElement = firstdiv.lastElementChild;

                    //Set New Hour
                    hourElement.textContent = `${editValues.begin}:00 - ${editValues.end}:00`;
                    hourElement.setAttribute(
                        "data-totalhour",
                        editValues.totalhour,
                    );

                    //Get Second Element Div Childs
                    let secondDivChilds = seconddiv.firstElementChild;

                    //Set New Total
                    secondDivChilds.firstElementChild.setAttribute(
                        "data-total",
                        editValues.subtotal,
                    );
                    secondDivChilds.firstElementChild.textContent = `Total: ${editValues.subtotal} € / `;

                    //Create Second Div Child Content - Total Hour
                    let totalhourcontent = htmlElements.createElement(
                        "small",
                        {
                            class: "totalhourcontent-pdp-details m-0",
                        },
                        `${editValues.totalhour} horas`,
                    );

                    //Append Element
                    secondDivChilds.firstElementChild.appendChild(
                        totalhourcontent,
                    );

                    //Set Attributes
                    value.setAttribute("data-totalhour", editValues.totalhour);
                    value.setAttribute("data-total", editValues.subtotal);
                }
            });
        },
        editReservePerTurn(element) {
            //Check Element
            if (
                element.target.hasAttribute("data-action") &&
                element.target.getAttribute("data-action") === "list"
            ) {
                //Show period turns
                calendarRoutine.showHideTurnList(element.target);

                return;
            }

            //Get Element
            calendarRoutine.dynamicUpdateSelectTurnId(
                element.target,
                "list-btnturn-pdpedit",
            );

            //Set Reserve Period Routine
            this.pdpedit.turndata = calendarRoutine.setHourOrPeriod(
                this.pdpedit.turndata,
                element.target,
            );
        },
        recalculateTotalAndPushEditVaulues(
            bookingDetailElementId,
            editvalueList,
            editValues,
            totalhourbase,
        ) {
            //Set Edit Values
            if (editvalueList.length === 0) {
                editvalueList.push(editValues);
            } else {
                //Get Element in Edit List
                let elementAlreadyEdit = editvalueList.findIndex(
                    (value) => value.id === parseInt(bookingDetailElementId),
                );

                //Check Element
                if (elementAlreadyEdit === -1) {
                    editvalueList.push(editValues);
                } else {
                    //Add new Edit Values
                    editvalueList.map((value, index) => {
                        if (value.id === parseInt(bookingDetailElementId)) {
                            //Change Values
                            value.begin = editValues.begin;
                            value.end = editValues.end;
                            value.subtotal = editValues.subtotal;
                            value.totalhour = editValues.totalhour;
                        }
                    });
                }
            }

            //Calculate Total
            let subtotal = 0;
            let oldSubTotal = 0;

            //Add new Edit Values
            editvalueList.forEach((value, index) => {
                //Plus edit subtotal price
                subtotal += parseFloat(value.subtotal);

                [
                    ...document.querySelector(".detail-reserve-list").children,
                ].forEach((val) => {
                    if (
                        val.firstElementChild.firstElementChild.textContent ===
                        value.day
                    ) {
                        oldSubTotal += parseFloat(
                            val.lastElementChild.firstElementChild.firstElementChild.getAttribute(
                                "data-total",
                            ),
                        );
                    }
                });
            });

            //console.log(subtotal);
            //console.log(oldSubTotal);
            //console.log(this.total);
            //console.log(editvalueList);

            this.total = parseFloat(this.total + (subtotal - oldSubTotal));

            return editvalueList;
        },
        getHourOrPeriodForAddNewDayReserve(element) {
            //Check Element
            if (
                element.target.hasAttribute("data-action") &&
                element.target.getAttribute("data-action") === "list"
            ) {
                //Show period turns
                calendarRoutine.showHideTurnList(element.target);

                return;
            }

            //Get Element
            calendarRoutine.dynamicUpdateSelectTurnId(
                element.target,
                "list-btnturn-addnewday",
            );

            //Check Element detail-reserve-list
            this.addnewday.turndata = calendarRoutine.setHourOrPeriod(
                this.addnewday.turndata,
                element.target,
            );
        },
        addNewDay() {
            //Check Reserver
            /*  if(Object.values(this.reserveData.reserver).length === 0){

                return;

            } */

            //Get Object Keys
            let reserverlisttype = Object.getOwnPropertyNames(
                this.reserveData.reserver,
            );

            //Day Exist
            let dayExist = false;

            //Create List of Days
            let listofdays = {
                days: [],
            };

            //Check if the day already exist in Reserve Data
            reserverlisttype.forEach((value) => {
                switch (value) {
                    //day
                    case "day":
                        dayExist =
                            this.reserveData.reserver[value] ===
                            this.addnewday.reserver.day;
                        listofdays.days.push(this.reserveData.reserver[value]);

                        break;

                    //days, interval, customdays
                    case "days":
                    case "interval":
                    case "customdays":
                        dayExist = this.reserveData.reserver[value].includes(
                            this.addnewday.reserver.day,
                        );
                        listofdays.days = this.reserveData.reserver[value];

                        break;
                }
            });

            //Show Callback Message
            if (dayExist) {
                //Show Message

                //Render Response Message
                responseMessage.renderResponseMessages(
                    this.$refs.responsebasemessage,
                    "danger",
                    "A data selecionada já existe na sua lista atual de Detalhes de Reserva",
                    this.activeclass,
                );

                //Disable Button
                document
                    .querySelector(".btnaddnewday")
                    .setAttribute("disabled", true);

                return;
            }

            //Check End and Begin Hour or Period
            switch (
                this.productData.rule.typeofreservation.unique_reservation
            ) {
                //Reserve per Hour
                case 1:
                    //Add Check Conditional for Hour Error
                    if (
                        this.addnewday.turndata.datahour.begin === "" ||
                        this.addnewday.turndata.datahour.end === "" ||
                        !calendarRoutine.checkValuesBeforeSend(
                            this.addnewday.turndata.datahour.begin,
                            this.addnewday.turndata.datahour.end,
                            "select-turn-morning-addnewday",
                            "select-turn-affternoon-addnewday",
                        )
                    ) {
                        //Render Response Message
                        responseMessage.renderResponseMessages(
                            this.$refs.responsebasemessage,
                            "danger",
                            "Por favor informar a hora de fim maior que a hora de início",
                            this.activeclass,
                        );

                        //Disable Button
                        document
                            .querySelector(".btnaddnewday")
                            .setAttribute("disabled", true);

                        return;
                    }

                    break;

                //Reserve per period
                case 2:
                    if (!Number.isInteger(this.addnewday.turndata.data)) {
                        //Show Message

                        //Render Response Message
                        responseMessage.renderResponseMessages(
                            this.$refs.responsebasemessage,
                            "danger",
                            "Por favor selecionar o período",
                            this.activeclass,
                        );

                        //Disable Button
                        document
                            .querySelector(".btnaddnewday")
                            .setAttribute("disabled", true);

                        return;
                    }

                    break;
            }

            //Set Add New Date
            let addNewDay = {
                reserver: this.addnewday.reserver,
                month: this.addnewday.reserver.month,
                year: this.addnewday.reserver.year,
                searchtype: this.addnewday.searchtype,
                turndata: {
                    type: this.addnewday.turndata.type,
                    datahour: {
                        begin: this.addnewday.turndata.datahour.begin,
                        end: this.addnewday.turndata.datahour.end,
                    },
                    data: this.addnewday.turndata.data,
                },
            };

            //Push New Day for Reserve Data
            if (this.reserveData.addnewdaylist.length === 0) {
                //Push New Day
                this.reserveData.addnewdaylist.push(addNewDay);
            } else {
                //Check if the day already exist in new days list
                let dayExistInList = this.reserveData.addnewdaylist.find(
                    (value) => value.reserver.day === addNewDay.reserver.day,
                );

                if (dayExistInList === undefined) {
                    //Push New Day
                    this.reserveData.addnewdaylist.push(addNewDay);
                } else {
                    //Show Message

                    //Render Response Message
                    responseMessage.renderResponseMessages(
                        this.$refs.responsebasemessage,
                        "danger",
                        "A data selecionada já existe na sua lista atual de Detalhes de Reserva",
                        this.activeclass,
                    );

                    //Disable Button
                    document
                        .querySelector(".btnaddnewday")
                        .setAttribute("disabled", true);

                    return;
                }
            }

            //Booking Details Structure
            this.bookingDetailsStructure(
                addNewDay,
                Object.getOwnPropertyNames(addNewDay.reserver),
            );

            //Set Day List for Input Date
            this.reserveData.addnewdaylist.forEach((value) => {
                listofdays.days.push(value.reserver.day);
            });

            //Set Object for create Reserve Date
            let reserveDateList = [];

            switch (this.reserveData.filterbymonth.length) {
                case 0:
                    reserveDateList.push(
                        this.reserveData.reserver,
                        this.addnewday.reserver,
                    );

                    break;

                default:
                    reserveDateList.push(this.addnewday.reserver);

                    this.reserveData.filterbymonth.forEach((value) =>
                        reserveDateList.push(value),
                    );

                    break;
            }

            //Set Reserve Date TextContent
            this.reservedate =
                calendarRoutine.searchContentMultipleMonths(reserveDateList);

            //Set Total Structure
            this.total = parseFloat(this.total);

            //Enabled Booking Button
            this.disabled = false;

            //Check Available Hour for Booking
            if (!this.availableHour) {
                this.disabled = true;
            }

            //Hide Modal
            this.hideModal("addnewdaymodal");
        },
        getBaseHourFromMainReservation(selecthourname) {
            return document.getElementById(`${selecthourname}`)
                ? parseInt(
                      document
                          .getElementById(`${selecthourname}`)
                          .textContent.replace(":00", ""),
                  )
                : null;
        },
        setDataForSendToBookingReservation(begin, end, turn) {
            let turndata = {
                begin: null,
                end: null,
                turn: null,
                subtotal: null,
                totalhour: null,
            };

            switch (
                this.productData.rule.typeofreservation.unique_reservation
            ) {
                //Per Hour
                case 1:
                    turndata.begin = begin;
                    turndata.end = end;
                    turndata.totalhour = turndata.end - turndata.begin;
                    break;

                //Per Period
                case 2:
                    turndata.turn = turn;
                    turndata.begin = this.getPerPeriodHourConditional(
                        turndata.turn,
                    );

                    //Period Variable
                    let turnInfoCalculateValues = this.dynamicCalculateTurnData(
                        turndata.turn,
                        turndata.begin
                    );

                    //Set data
                    turndata.end = turnInfoCalculateValues.end;
                    turndata.totalhour = turnInfoCalculateValues.total;

                    break;
            }

            return turndata;
        },
        getPerPeriodHourConditional(turnvalue) {
            //Get Begin Hour from each Turn
            let turn =
                this.productData.rule.typeofreservation.periodic_reserve_conditional.allturns.find(
                    (value) => value.id === turnvalue,
                );

            return turn !== undefined ? turn.begin : null;
        },
        sendBookingSetObjectData(
            bookingdata,
            month,
            year,
            begin = null,
            end = null,
            turn = null,
        ) {
            //Booking Default
            let bookingDefaultStructure = {
                day: bookingdata,
                month: month,
                year: year,
                turndata: {
                    begin: begin,
                    end: end,
                    turn: turn,
                    subtotal: null,
                    totalhour: null,
                },
            };

            //Set Booking Hour
            Object.assign(
                bookingDefaultStructure.turndata,
                this.setDataForSendToBookingReservation(
                    bookingDefaultStructure.turndata.begin,
                    bookingDefaultStructure.turndata.end,
                    bookingDefaultStructure.turndata.turn,
                ),
            );

            //Set Subtotal
            bookingDefaultStructure.turndata.subtotal =
                this.productData.value_number *
                bookingDefaultStructure.turndata.totalhour;

            return bookingDefaultStructure;
        },
        sendBooking() {
            //Check Total Value
            if ([-1, +0, -0].includes(Math.sign(this.total))) {
                //Render Response Message
                responseMessage.renderResponseMessages(
                    this.$refs.responsebasemessage,
                    "danger",
                    "O valor informado como total não pode ser processado",
                    this.activeclass,
                    7500,
                );

                return;
            }

            //Disabled Booking Button
            this.disabled = true;

            //Active Loading
            document.querySelector(".loadingbase").classList.add("d-flex");

            //Get Object Keys
            let reserverlisttype =
                this.reserveData.filterbymonth.length === 0
                    ? Object.getOwnPropertyNames(this.reserveData.reserver)
                    : Object.keys(this.reserveData.filterbymonth[0]);

            //Valid Reserve Key
            let validKey = reserverlisttype.find((value) =>
                this.defaulttypeofreserves.includes(value),
            );

            //TurnData Reserve
            let checkTurnData = true;

            //Check Reserve Data from TurnData
            switch (
                this.productData.rule.typeofreservation.unique_reservation
            ) {
                //Reserve per hour
                case 1:
                    checkTurnData =
                        Number.isInteger(
                            this.reserveData.turndata.datahour.begin,
                        ) &&
                        Number.isInteger(this.reserveData.turndata.datahour.end)
                            ? true
                            : false;

                    break;

                //Reserver per period
                case 2:
                    checkTurnData = Number.isInteger(
                        this.reserveData.turndata.data,
                    );

                    break;
            }

            //Check Reserve Data
            if (validKey === undefined || !checkTurnData) {
                //Disabled Booking Button
                this.disabled = true;

                //Render Response Message
                responseMessage.renderResponseMessages(
                    this.$refs.responsebasemessage,
                    "danger",
                    "Por favor enviar dados válidos",
                    this.activeclass,
                );

                //Desactive Loading
                document
                    .querySelector(".loadingbase")
                    .classList.remove("d-flex");

                return;
            }

            //Set Booking Data
            let bookingData = [];

            switch (validKey) {
                //Day
                case "day":
                    bookingData.push(
                        this.sendBookingSetObjectData(
                            this.reserveData.reserver[validKey],
                            this.reserveData.reserver.month,
                            this.reserveData.reserver.year,
                            this.getBaseHourFromMainReservation(
                                "refer-value-select-turn-morning-pdpbase",
                            ),
                            this.getBaseHourFromMainReservation(
                                "refer-value-select-turn-affternoon-pdpbase",
                            ),
                            this.reserveData.turndata.data,
                        ),
                    );

                    break;

                //Customdays, days, interval
                case "customdays":
                case "days":
                case "interval":
                    //Check by Multiple Reserve
                    switch (this.reserveData.filterbymonth.length) {
                        case 0:
                            this.reserveData.reserver[validKey].forEach(
                                (value) => {
                                    bookingData.push(
                                        this.sendBookingSetObjectData(
                                            value,
                                            this.reserveData.reserver.month,
                                            this.reserveData.reserver.year,
                                            this.getBaseHourFromMainReservation(
                                                "refer-value-select-turn-morning-pdpbase",
                                            ),
                                            this.getBaseHourFromMainReservation(
                                                "refer-value-select-turn-affternoon-pdpbase",
                                            ),
                                            this.reserveData.turndata.data,
                                        ),
                                    );
                                },
                            );

                            break;

                        default:
                            this.reserveData.filterbymonth.forEach((value) => {
                                if (Object.hasOwn(value, validKey)) {
                                    value[validKey].forEach((day) => {
                                        bookingData.push(
                                            this.sendBookingSetObjectData(
                                                day,
                                                value.month,
                                                value.year,
                                                this.getBaseHourFromMainReservation(
                                                    "refer-value-select-turn-morning-pdpbase",
                                                ),
                                                this.getBaseHourFromMainReservation(
                                                    "refer-value-select-turn-affternoon-pdpbase",
                                                ),
                                                this.reserveData.turndata.data,
                                            ),
                                        );
                                    });
                                }
                            });

                            break;
                    }

                    break;
            }

            //Check If Exist New Days
            if (this.reserveData.addnewdaylist.length > 0) {
                this.reserveData.addnewdaylist.forEach((value) => {
                    let checkAddNewDay = false;

                    //Check by Multiple Reserve
                    switch (this.reserveData.filterbymonth.length) {
                        case 0:
                            //Check Value
                            if (
                                Array.isArray(
                                    this.reserveData.reserver[validKey],
                                )
                            ) {
                                this.reserveData.reserver[validKey].forEach(
                                    (valday) => {
                                        if (
                                            this.reserveData.reserver.month ===
                                                value.reserver.month &&
                                            this.reserveData.reserver.year ===
                                                value.reserver.year &&
                                            valday === value.reserver.day
                                        ) {
                                            checkAddNewDay = false;
                                        }
                                    },
                                );
                            } else {
                                checkAddNewDay =
                                    this.reserveData.reserver.month ===
                                        value.reserver.month &&
                                    this.reserveData.reserver.year ===
                                        value.reserver.year &&
                                    this.reserveData.reserver[validKey] ===
                                        value.reserver.day;
                            }

                            break;

                        default:
                            ["customdays", "days"].forEach((type) => {
                                this.reserveData.filterbymonth.forEach(
                                    (reserver) => {
                                        if (
                                            Object.hasOwn(reserver, type) &&
                                            reserver.month ===
                                                value.reserver.month &&
                                            reserver.year ===
                                                value.reserver.year
                                        ) {
                                            checkAddNewDay = reserver[
                                                type
                                            ].includes(value.reserver.day);
                                        }
                                    },
                                );
                            });

                            break;
                    }

                    //Check List of Days From reserve
                    if (!checkAddNewDay) {
                        bookingData.push(
                            this.sendBookingSetObjectData(
                                value.reserver.day,
                                value.reserver.month,
                                value.reserver.year,
                                value.turndata.datahour.begin,
                                value.turndata.datahour.end,
                                value.turndata.data,
                            ),
                        );
                    } else {
                        bookingData.map((valday) => {
                            if (valday.day === value.reserver.day) {
                                //Set Booking Hour
                                Object.assign(
                                    valday.turndata,
                                    this.setDataForSendToBookingReservation(
                                        value.turndata.datahour.begin,
                                        value.turndata.datahour.end,
                                        value.turndata.data,
                                    ),
                                );

                                //Set Subtotal
                                valday.turndata.subtotal =
                                    this.productData.value_number *
                                    valday.turndata.totalhour;
                            }
                        });
                    }
                });
            }

            //Check If the Days have some edit actions
            if (this.reserveData.editvalues.length > 0) {
                this.reserveData.editvalues.forEach((value) => {
                    //Get Only the Correspondent Day
                    let day = value.day.split("-");

                    //Change Hour
                    bookingData.map((valbooking) => {
                        //Check Edit Day
                        if (valbooking.day === parseInt(day[0])) {
                            //Set Booking Hour
                            Object.assign(
                                valbooking.turndata,
                                this.setDataForSendToBookingReservation(
                                    value.begin,
                                    value.end,
                                    value.turndata !== null
                                        ? value.turndata.data
                                        : 1, //Security Value
                                ),
                            );

                            //Set Subtotal
                            valbooking.turndata.subtotal =
                                this.productData.value_number *
                                valbooking.turndata.totalhour;
                        }
                    });
                });
            }

            //Set Current Date
            let dateStructure = new Date();
            let basicToken = Math.round(Math.random() * this.total);
            let token =
                basicToken.toString() +
                "." +
                dateStructure.getDate().toString() +
                "." +
                dateStructure.getMonth().toString() +
                "." +
                dateStructure.getFullYear().toString();

            //Data Form
            let formData = {
                booking: {
                    bookingdata: bookingData,
                    bookingtypeoflocation:
                        this.productData.rule.typeofreservation
                            .unique_reservation,
                    bookingtotal: this.total,
                },
                product: {
                    id: this.productData.id,
                    company_id: this.productData.company_id,
                    location_id: this.productData.location_id,
                    basevalue: this.productData.value_number,
                    productdata: {
                        name: this.productData.name,
                        address: this.productData.data.address,
                        postalcode: this.productData.data.postalcode,
                        location_name: this.productData.location_name,
                        mediadata: this.mediaData,
                        url: window.location.href,
                    },
                },
                token: btoa(token),
            };

            //Set Token
            sessionStorage.setItem(
                "pdp_checkout",
                JSON.stringify(formData.token),
            );

            //Send Data
            let response = fetchData.structureTosendData(
                this.bookingurl,
                formData,
                this.csrftolken,
                "POST",
            );

            //Check Promisse
            response
                .then((value) => {
                    //Desactive Loading
                    document
                        .querySelector(".loadingbase")
                        .classList.remove("d-flex");

                    //Enabled Button
                    //this.disabled = false;

                    //Add active Class
                    this.$refs.responsebasemessage.classList.add(
                        this.activeclass,
                    );
                    this.$refs.responsebasemessage.classList.add(
                        value.classname,
                    );

                    //Element for append
                    let li = responseMessage.messageStructure(
                        value.message,
                        value.classname,
                    );

                    //Append Element
                    $(li).appendTo(this.$refs.responsebasemessage.children);

                    //Remove Message
                    responseMessage.removeResponseMessages(7000);

                    //Check Type of Response
                    switch (value.classname) {
                        //Warning
                        case "warning":
                            //Disabled Button
                            this.disabled = true;

                            //Inform Not Available Day
                            [
                                ...document.querySelector(
                                    ".detail-reserve-list",
                                ).children,
                            ].forEach((valbooking) => {
                                if (
                                    value.data.includes(
                                        parseInt(
                                            valbooking.getAttribute("data-day"),
                                        ),
                                    ) &&
                                    !valbooking.classList.contains(
                                        "noavailable",
                                    )
                                ) {
                                    //Add Class
                                    valbooking.classList.add("noavailable");
                                }
                            });

                            break;

                        //Success
                        case "success":
                            //Disabled Button
                            this.disabled = true;

                            //Redirect after delay
                            setTimeout(() => {
                                //Redirect for Admin Route
                                window.location.replace(value.data);
                            }, 3500);

                            //Clean Time Out
                            //clearTimeout();

                            break;
                    }

                    return;
                })
                .catch((error) => {
                    //Enabled Button
                    this.disabled = false;

                    //Desactive Loading
                    document
                        .querySelector(".loadingbase")
                        .classList.remove("d-flex");

                    throw new Error(error);
                });
        },
        dynamicCalculateTurnData(indicateTurn, begin, blockofhour = null){

            let turnInfoCalculateValues = {
                end: null,
                total: null,
                blockofhour: blockofhour
            }

            //Period Variable
            switch (indicateTurn) {
                case 3:
                    turnInfoCalculateValues.end =
                        begin +
                        (this.productData.rule.typeofreservation
                            .periodic_reserve_conditional
                            .block_of_hour *
                            this.turnWeightValue);
                    turnInfoCalculateValues.total = turnInfoCalculateValues.end - begin;

                    //Add a hour related lunch time
                    turnInfoCalculateValues.end = turnInfoCalculateValues.end + 1;

                    //Block of hour
                    if(turnInfoCalculateValues.blockofhour !== null){

                        turnInfoCalculateValues.blockofhour = turnInfoCalculateValues.blockofhour * this.turnWeightValue;

                    }

                break;

                default:
                    turnInfoCalculateValues.end =
                        begin +
                        this.productData.rule.typeofreservation
                            .periodic_reserve_conditional.block_of_hour;
                    turnInfoCalculateValues.total = turnInfoCalculateValues.end - begin;

                    //Block of hour
                    if(turnInfoCalculateValues.blockofhour !== null){

                        turnInfoCalculateValues.blockofhour = turnInfoCalculateValues.blockofhour;

                    }

                break;
            }

            return turnInfoCalculateValues;

        }
    },
    computed: {
        computedReserveData() {
            return this.reserveData;
        },
        computedTotal() {
            return this.total;
        },
        computedPdpEdit() {
            return this.pdpedit;
        },
        computedAddNewDay() {
            return this.addnewday;
        },
        computedAvailableHour() {
            return this.availableHour;
        },
        computedPdpImage() {
            return this.pdpimage;
        },
    },
    watch: {
        computedReserveData() {},
        computedTotal() {},
        computedPdpEdit() {},
        computedAddNewDay() {},
        computedAvailableHour() {},
        computedPdpImage() {},
    },
    components: {
        modal: Modal,
        tableElement: Table,
        loading: Loading,
        listMessage: ListMessage,
        calendarElement: CalendarElement,
    },
    destroyed() {
        //Clean Old Data
        this.productData = {};
        this.customData = {};
        this.mediaData = {};
    },
};
</script>
